import { WarningOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DynamicTooltip } from './DynamicTooltip';

export const SupplierRejectedTooltip = () => {
    const { t } = useTranslation();
    return (
        <DynamicTooltip
            content={
                <div>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontWeight: '600',
                            color: '#FF0000',
                            marginBottom: '8px',
                        }}
                    >
                        {t('Action Required')}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            lineHeight: '1.4',
                        }}
                    >
                        {t(
                            'Supplier is experiencing an issue enabling your account.',
                        )}
                        <br />
                        {t('Please contact them to resolve the issue.')}
                        <br />
                        {t('Your account must be enabled to submit orders.')}
                    </Typography>
                </div>
            }
        >
            <WarningOutlined
                sx={{
                    color: '#FF0000',
                    fontSize: '15px',
                    marginTop: '4px',
                }}
            />
        </DynamicTooltip>
    );
};
